import { render, staticRenderFns } from "./PlatenSettingSave.vue?vue&type=template&id=160626e5&scoped=true&"
import script from "./PlatenSettingSave.vue?vue&type=script&lang=js&"
export * from "./PlatenSettingSave.vue?vue&type=script&lang=js&"
import style0 from "./PlatenSettingSave.vue?vue&type=style&index=0&id=160626e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160626e5",
  null
  
)

export default component.exports